import React from "react";
import {Button, Confirm, Grid, Modal, Popup} from "semantic-ui-react";
import {
    deleteCurrentDataService,
    toggleDeleteServiceWarning,
} from "../../actions/ServiceDetailActions";
import {connect} from "react-redux";
import ServiceDetailInfo from "./ServiceDetailInfo";
import {closeAddEditModal, openEditModal} from "../../../add-edit/actions/AddEditActions";
import * as Validation from "../../../../common/utils/Validation";
import {validateDPService} from "../../../add-edit/actions/AddEditDPServiceActions";
import PropTypes from "prop-types";
import {toggleApproval} from "../../../../middlewares/veritas-middleware/actions/UtilityMiddlewareActions";
import AdditionalDetails from "./AdditionalDetails";
import DPServicesForm from "../../../add-edit/components/DPServicesForm";
import lodash from "lodash/core";
import Breadcrumb from "../../../../common/partials/Breadcrumb";
import {setBreadCrumb} from "../../../breadcrumb/BreadcrumbActions";
import LastUpdated from "../../../../common/partials/LastUpdated";

// since we are using hard-coded values for these options, having this object here
// in case the redux state is is not already populated
const subDPTypeOptionsHC = [
    { label: "Business Verification", value: "bv" },
    { label: "BV", value: "bv+" },
    { label: "ODO", value: "odo" },
    { label: "KYB", value: "kyb" },
];
export class ServiceDetailPage extends React.Component {

    static propTypes =  {
        resourceType: PropTypes.string,
        serviceDetail: PropTypes.object,
        dpInputFields: PropTypes.array,
        requiredInputs: PropTypes.array,
        dpSources: PropTypes.array,
    }

    componentDidMount() {
        const { resourceType, serviceDetail } = this.props;

        const parentURL = '/veritas';
        const serviceTypeURL = resourceType === 'kyc' ? '/kyc-services' : '/kyb-services';
        const listText = resourceType === 'kyc' ? 'KYC Services' : 'KYB Services';
        const listURL = parentURL + serviceTypeURL

        this.props.setBreadCrumb({
            parent:  { url: parentURL, text: 'Veritas' },
            list:    { url: listURL, text: listText },
            service: { url: `/veritas/kyc-services/${serviceDetail.service_detail.service_id}`, text: '' },
            source:  { url: '', text: '' },
        })
    }


    handleCloseButtonClick = () => {
        Validation.clearMessages();
        this.props.closeModal("DP Service");
    }

    handleEditButtonClick = () => {
        const {serviceDetail} = this.props;
        this.props.openEditModal("DP Service", serviceDetail);
    }

    handleEditDPServiceSubmit(e) {
        e.preventDefault();
        const { serviceObject, toDelete } = this.props;
        this.props.validateDPService(serviceObject, toDelete);
    }

    handleDeleteButtonClick = () => {
        this.props.toggleServiceDeleteWarning();
    }

    handleCancelServiceDelete = () => {
        this.props.toggleServiceDeleteWarning();
    }

    handleConfirmServiceDelete = () => {
        const {serviceDetail} = this.props;
        this.props.deleteCurrentDataService(serviceDetail.service_detail.service_id, serviceDetail.service_detail.dp_type);
    }

    handleServiceApprovalsButtonClick = () => {
        const {serviceDetail} = this.props;
        this.props.toggleApproval("dpService", serviceDetail.approvals);
    }


    get serviceName() {
        const {serviceDetail, canEdit, canApprove, all_service_sets} = this.props;
        const lastUpdatedOnDate = serviceDetail.service_detail.last_updated;

        return(
            <div className="header-container">
                <div className="title-alignment">
                    <span className="detail-name">
                        <h1 >{serviceDetail.service_detail.service_name}</h1>
                    </span>
                    {canEdit
                        ? (
                            <span className="buttons-alignment">
                                <Popup
                                    content={"Edit"}
                                    trigger={
                                        <Button
                                        onClick={this.handleEditButtonClick}
                                        icon="edit outline"
                                        />
                                    }
                                />
                                <Popup
                                    content={"Delete"}
                                    trigger={
                                        <Button
                                            onClick={this.handleDeleteButtonClick}
                                            color={"red"}
                                            icon="trash alternate outline"
                                        />
                                    }
                                />
                            </span>
                        )
                        : null
                    }
                </div>
                <div className="title-alignment" style={{height: "30px"}}>
                    <span className="detail-config-name">
                        {serviceDetail.service_config_names
                            ? serviceDetail.service_config_names.map((svcConfig, idx) => {
                                if(svcConfig.is_primary) {
                                    return (
                                        <span key={idx}>
                                           <h3>
                                            {svcConfig.name} ({lodash.find(all_service_sets, {
                                               collectionid: svcConfig.collectionid}).name})
                                            </h3>
                                        </span>
                                    )
                                } else { return null }
                            })
                            : null
                        }
                    </span>
                        {canApprove
                            ? (
                                <span className="buttons-alignment" >
                                    <div className="flex">
                                        <Button
                                            content={serviceDetail.approvals.is_approved === false
                                                ? "Not Approved" : "Approved"}
                                            color={serviceDetail.approvals.is_approved === false ? "red" : "green"}
                                            onClick={this.handleServiceApprovalsButtonClick}
                                        />
                                        <label> Last Updated On: </label> 
                                        <LastUpdated lastUpdated={lastUpdatedOnDate} />
                                    </div>
                                </span>
                            )
                            : null
                        }
                </div>
            </div>
        );
    }

    // this method can be removed later and additional details component
    // can be straight added to the render method.
    get additionalDetails() {
        return (
            <div>
                <AdditionalDetails />
            </div>
        )
    }

    render() {

        const {
            dpServiceModalHeader,
            editModalOpenDPService,
            serviceDetail,
            deleteServiceWarning,
            associatedCountries,
            resourceType,
            dpInputFields, requiredInputs, dpSources, subDPTypeOptions,
        } = this.props;
        const confirmMessage = `Are you sure you want to delete ${serviceDetail.service_detail.service_name} ?
        This action cannot be undone.`

        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Grid relaxed={true}>
                        <Grid.Column width={12}>
                            <Breadcrumb />
                            <div style={{ padding: "20px 20px 0 20px" }}>
                                {this.serviceName}
                                <ServiceDetailInfo
                                    resourceType={resourceType}
                                    associatedCountries={associatedCountries}
                                    serviceDetail={serviceDetail}
                                    dpInputFields={dpInputFields}
                                    requiredInputs={requiredInputs}
                                    dpSources={dpSources}
                                    subDPTypeOptions={subDPTypeOptions.length === 0
                                        ? subDPTypeOptionsHC
                                        :subDPTypeOptions}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column width={4} style={{paddingLeft: "0"}}>
                            <AdditionalDetails />
                        </Grid.Column>
                    </Grid>
                </div>

                <Modal
                    centered={false}
                    open={editModalOpenDPService}
                >
                    <Modal.Header>
                        {dpServiceModalHeader}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <DPServicesForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button type="button" color="red" inverted onClick={this.handleCloseButtonClick}>
                            Close
                        </Button>
                        <Button color="green" inverted type="submit" onClick={e => this.handleEditDPServiceSubmit(e)}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={deleteServiceWarning}
                    content={confirmMessage}
                    onCancel={this.handleCancelServiceDelete}
                    onConfirm={this.handleConfirmServiceDelete}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    deleteServiceWarning: state.veritas.serviceDetail.deleteServiceWarning,
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    canApprove: state.marvel.user.access.accessLevel.isDPAdmin,

    subDPTypeOptions: state.veritas.kybServices.kybFilterOptions.subDPTypeOptions,

    editModalOpenDPService: state.veritas.addEdit.addEditDPService.editModalOpenDPService,
    dpServiceModalHeader: state.veritas.addEdit.addEditDPService.dpServiceModalHeader,
    editedRequiredInputs: state.veritas.addEdit.addEditDPService.requiredInputs,
    serviceObject: state.veritas.addEdit.addEditDPService.serviceObject,
    toDelete: state.veritas.addEdit.addEditDPService.toDelete,
    statusOptions: state.veritas.addEdit.addEditDPService.statusOptions,

    all_service_sets: state.veritas.services.all_service_sets,
    associatedTenants: state.veritas.serviceDetail.associatedTenants,
    associatedCountries: state.veritas.serviceDetail.associatedCountries,
});

const mapDispatchToProps = dispatch => ({
    openEditModal: (type, detailObject) => {dispatch(openEditModal(type, detailObject))},
    closeModal: (type) => {dispatch(closeAddEditModal(type))},
    validateDPService: (serviceObject, toDelete) => {dispatch(validateDPService(serviceObject, toDelete))},
    toggleServiceDeleteWarning: () => {dispatch(toggleDeleteServiceWarning())},
    deleteCurrentDataService: (serviceID, dp_type) => {dispatch(deleteCurrentDataService(serviceID, dp_type))},
    toggleApproval: (type, approvalsObject) => {dispatch(toggleApproval(type, approvalsObject))},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceDetailPage)
